/** @param {string} path absolute app path starting with / */
export function localizePath(path, localePrefix) {
  if (typeof path !== 'string' || !path.startsWith('/')) {
    return path;
  }
  if (localePrefix === '/en') {
    if (path === '/') {
      return '/en';
    }
    return `/en${path}`;
  }
  return path;
}

/** BCP 47 locale for Date/locale APIs */
export function getDateLocale(appLocale) {
  return appLocale === 'en' ? 'en-GB' : 'fr-FR';
}
